interface Props {
  value: string;
  tabs: {
    value: string;
    label: string | JSX.Element;
  }[];
  onSelect: (value: string) => void;
}

const ButtonTabsV2 = ({ value, tabs, onSelect }: Props) => {
  if (tabs.length === 1) return null;

  const renderTabs = () => {
    return tabs.map((t) => {
      const isSelected = t.value === value;

      return (
        <div
          key={t.value}
          className={`cursor-pointer rounded-full border border-primary fill-primary p-[15px] text-primary dark:border-white dark:fill-white dark:text-white ${
            isSelected && "border-primary bg-primary fill-white text-white"
          }`}
          onClick={() => {
            onSelect(t.value);
          }}
        >
          {t.label}
        </div>
      );
    });
  };

  return (
    <div className="flex items-center justify-start gap-x-6 px-10 pb-4">
      {renderTabs()}
    </div>
  );
};

export default ButtonTabsV2;
